const menu = {
    label: 'Meu QRCode',
    icon: 'pi pi-fw pi-qrcode',
    to: '/checkins/credenciamento',
    rules: ['CHECKINS-CREDENC-00'],
};

export default menu;
